<template>
    <div class="loader">
        <div class="loader__icon" />
    </div>
</template>

<script>
export default {
    name: 'CustomLoader'
}
</script>

<style>

.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 50%;
}

.loader__icon {
  width: 85px;
  height: 85px;
  border-radius: 50%;
  border: 5px dotted teal;
  box-shadow: 0 0 15px rgba(255,255,255,.3);
  animation: rotate 5s infinite linear;
}

@keyframes rotate {
  from {
    transform: rotate(0deg) scale(0.5);
  }

  to {
    transform: rotate(360deg) scale(1.0);
  }
}
</style>